/* each section active state */
export enum CarConfigConfigureSectionsLbx {
    AtmosphereWelcome = "welcome",
    AtmosphereGrade = "customize-grade",
    AtmosphereColor = "customize-colour",
    AtmosphereUpholstery = "customize-upholstery",
    AtmosphereWheels = "customize-wheels",
    Packs = "customize-packs",
    Extras = "customize-extras",
    Powertrain = "customize-powertrain",
    Services = "carconfig-services",
    Summary = "carconfig-summary",
}
